import React from "react";
import "./GolferDrawn.css";
import { useStateValue } from "./StateProvider";
import { db } from "./firebase";

function GolferDrawn({ golfer }) {
  const [{ eventDate }] = useStateValue();

  const getStyle = () => {
    if (golfer.isDrawn) {
      return drawn;
    } else {
      return notDrawn;
    }
  };

  const notDrawn = {
    color: "black",
    backgroundColor: "lightgreen",
  };
  const drawn = {
    color: "white",
    backgroundColor: "red",
    border: "1px solid black",
  };
  const scoresEntered = {
    color: "black",
    backgroundColor: "white",
  };

  return (
    <div className="golfer" style={getStyle()}>
      <div className="golfer__info1">
        {/* <span className="golfer__name">
          {golfer.idgame} {golfer.name}
          
          {golfer.isDrawnNum}
        </span> */}
        <div>{golfer.idgame}</div>
        <div>{golfer.name}</div>
        <div>{golfer.isDrawnNum}</div>
      </div>
    </div>
  );
}

export default GolferDrawn;
